import React, { useEffect, useState } from "react";
import { isAxiosError } from "axios";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useLocation, useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";

interface ISongInfoDB {
  id: number;
  title: string;
  accepted?: string | null;
  zaakceptowane?: string;
}

interface BandChosenSongsListProps {
  bandNumber: number;
  year: number;
}

const BandChosenSongsList = ({ bandNumber, year }: BandChosenSongsListProps) => {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();
  const INFO_URL = `/admin/songs/${bandNumber}`;

  const [acceptedTitles, setAcceptedTitles] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!bandNumber) return;
    const controller = new AbortController();
    const fetchSongs = async () => {
      setLoading(true);
      try {
        const response = await axiosPrivate.get(INFO_URL, {
          signal: controller.signal,
          params: { year },
        });
        let songsData: ISongInfoDB[] = [];
        if (typeof response.data === "string") {
          setAcceptedTitles([]);
          return;
        }
        if (Array.isArray(response.data)) {
          songsData = response.data;
        } else if (response.data?.songs && Array.isArray(response.data.songs)) {
          songsData = response.data.songs;
        }
        const titles = songsData
          .filter(
            (s: ISongInfoDB) =>
              (s.accepted ?? s.zaakceptowane) === "tak"
          )
          .map((s: ISongInfoDB) => s.title);
        setAcceptedTitles(titles);
      } catch (error) {
        if (isAxiosError(error)) {
          if (error.response?.status === 403) {
            navigate("/", { state: { from: location }, replace: true });
          } else {
            setAcceptedTitles([]);
          }
        } else {
          setAcceptedTitles([]);
        }
      } finally {
        setLoading(false);
      }
    };
    fetchSongs();
    return () => controller.abort();
  }, [bandNumber, year]);

  if (loading) {
    return (
      <Typography variant="body2" color="white">
        Ładowanie...
      </Typography>
    );
  }
  if (acceptedTitles.length === 0) {
    return (
      <Typography variant="body2" color="white">
        Brak wybranych piosenek. Kliknij „Choose Songs”, aby wybrać.
      </Typography>
    );
  }
  return (
    <ul className="band-chosen-songs-list">
      {acceptedTitles.map((title) => (
        <li key={title}>{title}</li>
      ))}
    </ul>
  );
};

export default BandChosenSongsList;
